<ng-container *ngIf="isLoading">
    <div class="loader-container">
        <span class="loader"></span>
    </div>
</ng-container>